import { FC } from "react";
import clsx from "clsx";
import { TON_CONNECT_TEXT } from "../../constants/walletAssociation.constants";
import TonConnectButton from "./TonConnectButton";
import styles from "./TonWalletGate.module.scss";

interface TonWalletGateProps {
  disabled?: boolean;
  onAssociated?: () => void;
  onError?: (error: string) => void;
  className?: string;
}

/**
 * Reusable "TON Wallet Required" section rendered on purchase surfaces when an
 * IDO has `tonSupport`. Wraps {@link TonConnectButton} so PreOrderForm and the
 * sale widget share one implementation instead of duplicating the markup.
 */
export const TonWalletGate: FC<TonWalletGateProps> = ({
  disabled = false,
  onAssociated,
  onError,
  className,
}) => (
  <div className={clsx(styles.tonWalletSection, className)}>
    <h4 className={styles.tonWalletTitle}>{TON_CONNECT_TEXT.SECTION_TITLE}</h4>
    <p className={styles.tonWalletDescription}>
      {TON_CONNECT_TEXT.SECTION_DESCRIPTION}
    </p>
    <TonConnectButton
      className={styles.tonConnectButton}
      disabled={disabled}
      onAssociated={onAssociated}
      onError={onError}
    />
  </div>
);

export default TonWalletGate;
